import { ArticleImage } from '@/types/articles';
/**
 * Returns the requested image size for an image object or if not found
 * returns the original image size url. Prefixes the CMS url to the image.
 */
export const prepareArticleImage = (
  image: ArticleImage | undefined,
  size: 'small' | 'medium' | 'large' | 'original'
): string => {
  if (!image) {
    return '';
  }

  const imageUrl = image[size] ? (image[size] as string) : image.original;
  return `${imageUrl}`;
};
